module.exports = __webpack_public_path__ + "img/fruit_face_guide_poster.feb44048.png";